<div class="container mini-cart" *ngIf="cart.entries">
  <!--empty cart detail starts-->
  <div
    class="mini-cart-empty-cart container"
    *ngIf="!cart.entries.length"
  >
    <div class="row cart-img">
      <span class="empty-cart-img"></span>
    </div>
    <div class="row cart-heading-one">
      <h4 class="empty-cart-msg-one">{{ "miniCartDetail.emptyCartHeader" | cxTranslate }}</h4>
    </div>
    <div class="row cart-heading-two">
      <h4 class="empty-cart-msg-two">
        {{ "miniCartDetail.browseProducts" | cxTranslate }}
      </h4>
    </div>
  </div>
  <!--empty cart detail ends-->
  <!--cart detail starts-->

  <div class="mini-cart-detail container" *ngIf="cart.entries.length">
    <div class="row" class="total-price-row">
      <div class="total-price col-md-12">
        <h4 class="total-price-detail-heading">
          {{ "miniCartDetail.showingHeader" | cxTranslate }} {{ cart.entries.length > 5 ? '5' : cart.entries.length }} {{ "miniCartDetail.outOf" | cxTranslate }}
          {{ cart.entries.length }} {{ "miniCartDetail.productHeader" | cxTranslate }}
        </h4>
        <!-- <h4 class="total-price-detail-heading">
          Showing {{ cart.entries.length > 3 ? '3' : cart.entries.length }} out of
          {{ cart.totalUnitCount }} products
        </h4> -->


        <!-- <h3 class="total-price-detail-total-heading">
          {{ "miniCartDetail.totalHeader" | cxTranslate }} : {{cart.totalPriceWithTax.currencyIso }} {{ cart.totalPriceWithTax.formattedValue }}
        </h3> -->
      </div>
    </div>

    <div class="cart-row" *ngFor="let cartlist of prodname; let i = index">
    <div class="cart-product-detail row"  *ngIf="i < 5">
       <div class="col-md-3 custom-margin">
        <cx-media 
        class="detail-img" 
        [container]="cartlist?.product?.images?.PRIMARY"
      ></cx-media> 
        <!-- <img class="detail-img" src="" /> -->
       </div>
    
      <div class="cart-product-detail-text col-md-6">
        <h5 class="cart-part-number">
          <a class="cart-heading" (click)="setProductDetailsGTM(cartlist)" [routerLink]="['product',cartlist?.product.code, cartlist?.product.name]"> {{ cartlist?.product.code }}</a>
         
        </h5>
       <span class="text-hidden">{{ cartlist?.product.code }}</span>
        <h5 class="cart-product-desc">
          <a class="cart-desc" (click)="setProductDetailsGTM(cartlist)" [routerLink]="['product',cartlist?.product.code, cartlist?.product.name]"> {{ cartlist?.product.name }}</a>
         
        </h5>
        <span class="text-hidden">{{ cartlist?.product.name }}</span>
      </div>
      <div class="cart-product-detail-qty col-md-3 custom-padding-left-zero">
        <h5 class="cart-qty-heading">{{ "miniCartDetail.quantityHeader" | cxTranslate }}</h5>
        <h5 class="cart-qty-number"><a class="cart-qty" (click)="setProductDetailsGTM(cartlist)" [routerLink]="['product',cartlist?.product.code, cartlist?.product.name]">{{ cartlist?.quantity }}</a></h5>
      </div>
    </div>
  </div>
  <div class="row custom-mini-cart-padding">
    <h3 class="total-price-detail-total-heading">
      {{ "miniCartDetail.totalHeader" | cxTranslate }} : <span class="span-total-heading">{{cart.totalPriceWithTax.currencyIso }} {{ cart.totalPriceWithTax.formattedValue }}
      </span></h3>
  </div>
    <div class="row">
      <button  [routerLink]="{ cxRoute: 'cart' } | cxUrl"    
      autofocus class="vs-tertiary-btn custom-cart-btn" (click)="closeMiniCart($event)">{{ "miniCartDetail.viewCartBtn" | cxTranslate }}</button>
    </div>
  </div>
  <!--cart detail ends-->
</div>
